import { doGetOld as baseGetOld } from './base'
import { doGetOld, doPostOld, doPatchOld } from './myBase'

export const getCustomerDetails = async (): Promise<CustomerDetailsResponse> => {
  return await doGetOld('/api/customers/details')
}

export const updateDetails = async (
  details: CustomerDetailsRequest
): Promise<UpdateCustomerDetailsResponse> => {
  return await doPatchOld('/api/customers', details)
}

export const getPrimaryCardDetails = async (): Promise<PaymentCardResponse> => {
  return await baseGetOld('/api/customers/primary_card')
}

export const requestEmailChange = async (newEmail: string): Promise<ApiNoContentResponse> => {
  return await doPostOld('/api/customers/change_email', {
    new_email: newEmail
  })
}

export const resendChangeEmailInstructions = async (): Promise<ApiNoContentResponse> => {
  return await doPostOld('/api/customers/resend_change_email_instructions')
}

export const verifyEmailChange = async (token: string): Promise<VerifyEmailChangeResponse> => {
  return await doPostOld('/api/customers/verify_change_email', { token })
}

export const verifyCustomerAccount = async (token: string): Promise<VerifyAccountResponse> => {
  return await doPostOld(`/api/customers/verify/${token}`)
}

export default {
  updateDetails,
  getPrimaryCardDetails,
  requestEmailChange,
  resendChangeEmailInstructions,
  verifyEmailChange,
  getCustomerDetails,
  verifyCustomerAccount
}
